export const GLASGOWCLLRS = [
	{
		name: "Saqib Ahmed",
		party: "Labour",
		ward: "Greater Pollok",
		email: "saqib.ahmed@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Susan Aitken",
		party: "SNP",
		ward: "Langside",
		email: "susan.aitken@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Imran Alam",
		party: "Labour",
		ward: "Govan",
		email: "Imran.Alam@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Blair Anderson",
		party: "Green",
		ward: "Partick East/Kelvindale",
		email: "Blair.Anderson@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Ken Andrew",
		party: "SNP",
		ward: "Hillhead",
		email: "ken.andrew@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Alexander Belic",
		party: "SNP",
		ward: "Southside Central",
		email: "alexander.belic@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Richard Bell",
		party: "SNP",
		ward: "Govan",
		email: "richard.bell@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Declan Blench",
		party: "SNP",
		ward: "East Centre",
		email: "Declan.Blench@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Eva Bolander",
		party: "SNP",
		ward: "Anderston/City/Yorkhill",
		email: "eva.bolander@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Abdul Bostani",
		party: "SNP",
		ward: "Maryhill",
		email: "Abdul.Bostani@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Philip Braat",
		party: "Labour",
		ward: "Anderston/City/Yorkhill",
		email: "philip.braat@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Jill Brown",
		party: "Labour",
		ward: "Partick East/Kelvindale",
		email: "Jill.Brown@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Holly Bruce",
		party: "Green",
		ward: "Langside",
		email: "Holly.Bruce@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Maureen Burke",
		party: "Labour",
		ward: "North East",
		email: "maureen.burke@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bill Butler",
		party: "Labour",
		ward: "Garscadden/Scotstounhill",
		email: "bill.butler@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Graham Campbell",
		party: "SNP",
		ward: "Springburn/Robroyston",
		email: "graham.campbell@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Christina Cannon",
		party: "SNP",
		ward: "Springburn/Robroyston",
		email: "christina.cannon@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Paul Carey BEM",
		party: "Labour",
		ward: "Drumchapel/Anniesland",
		email: "paul.carey@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Anthony Carroll",
		party: "Green",
		ward: "Dennistoun",
		email: "Anthony.Carroll@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "John Carson",
		party: "Labour",
		ward: "Linn",
		email: "John.Carson@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Allan Casey",
		party: "SNP",
		ward: "Drum Brae/Gyle",
		email: "allan.casey@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Annette Christie",
		party: "SNP",
		ward: "East Centre",
		email: "annette.christie@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Chris Cunningham",
		party: "SNP",
		ward: "Garscadden/Scotstounhill",
		email: "chris.cunningham@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Stephen Curran",
		party: "Labour",
		ward: "Newlands/Auldburn",
		email: "stephen.curran@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Feargal Dalton",
		party: "SNP",
		ward: "Victoria Park",
		email: "feargal.dalton@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "John Daly",
		party: "Tory",
		ward: "Baillieston",
		email: "John.Daly3@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Audrey Dempsey",
		party: "Independent",
		ward: "Springburn/Robroyston",
		email: "Audrey.Dempsey@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Stephen Docherty",
		party: "Labour",
		ward: "Langside",
		email: "Stephen.Docherty@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Laura Doherty",
		party: "SNP",
		ward: "Shettleston",
		email: "laura.doherty@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Stephen Dornan",
		party: "SNP",
		ward: "Govan",
		email: "stephen.dornan@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Patricia Ferguson",
		party: "Labour",
		ward: "Inverleith",
		email: "Drumchapel/Anniesland",
		twitter: "none",
	},
	{
		name: "Sean Ferguson",
		party: "SNP",
		ward: "Newlands/Auldburn",
		email: "Sean.Ferguson@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Elaine Gallagher",
		party: "Green",
		ward: "Southside Central",
		email: "Elaine.Gallagher@glasgow.gov.uk",
		twitter: "@none",
	},
	{
		name: "Zen Ghani",
		party: "SNP",
		ward: "Pollokshields",
		email: "Zen.Ghani@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Allan Gow",
		party: "SNP",
		ward: "Canal",
		email: "allan.gow@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "William Graham",
		party: "SNP",
		ward: "Greater Pollok",
		email: "William.Graham2@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Sharon Greer",
		party: "Labour",
		ward: "North East",
		email: "Sharon.Greer@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Greg Hepburn",
		party: "SNP",
		ward: "Calton",
		email: "greg.hepburn@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Fiona Higgins",
		party: "Labour",
		ward: "Canal",
		email: "Fiona.Higgins@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Seonad Hoy",
		party: "Green",
		ward: "Hillhead",
		email: "seonad.hoy@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Rashid Hussain",
		party: "Labour",
		ward: "Greater Pollok",
		email: "rashid.hussain@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Dan Hutchison",
		party: "Green",
		ward: "Govan",
		email: "dan.hutchison@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Fyeza Ikhlaq",
		party: "SNP",
		ward: "Drumchapel/Anniesland",
		email: "Fyeza.Ikhlaq@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Eunis Jassemi",
		party: "Labour",
		ward: "Victoria Park",
		email: "Eunis.Jassemi@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Ann Jenkins",
		party: "Labour",
		ward: "East Centre",
		email: "Ann.Jenkins@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Lilith Johnstone",
		party: "Labour",
		ward: "Partick East/Kelvindale",
		email: "nLilith.Johnstone@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Jim Kavanagh",
		party: "Labour",
		ward: "Cardonald",
		email: "jim.kavanagh@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Ruairi Kelly",
		party: "SNP",
		ward: "North East",
		email: "ruairi.kelly@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Alex Kerr",
		party: "SNP",
		ward: "Baillieston",
		email: "Alex.Kerr@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Matt Kerr",
		party: "Labour",
		ward: "Cardonald",
		email: "matthew.kerr@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Thomas Kerr",
		party: "Tory",
		ward: "Shettleston",
		email: "thomas.kerr2@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Kevin Lalley",
		party: "SNP",
		ward: "Baillieston",
		email: "Kevin.Lalley@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Paul Leinster",
		party: "SNP",
		ward: "Langside",
		email: "Paul.Leinster@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Frank McAveety",
		party: "Labour",
		ward: "Shettleston",
		email: "frank.mcaveety@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Paul McCabe",
		party: "SNP",
		ward: "Linn",
		email: "Paul.McCabe@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Elaine McDougall",
		party: "Labour",
		ward: "Dennistoun",
		email: "elaine.mcdougall@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Lord Provost Jacqueline McLaren",
		party: "SNP",
		ward: "Canal",
		email: "jacqueline.mclaren@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Kenny McLean",
		party: "SNP",
		ward: "Partick East/Kelvindale",
		email: "kenny.mclean@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Norman MacLeod",
		party: "SNP",
		ward: "Pollokshields",
		email: "norman.macleod@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Elaine McSporran",
		party: "SNP",
		ward: "Cardonald",
		email: "elaine.mcsporran@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Anne McTaggart",
		party: "SNP",
		ward: "Drumchapel/Anniesland",
		email: "anne.mctaggart@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Leòdhas Massie",
		party: "Green",
		ward: "Newlands/Auldburn",
		email: "Leodhas.Massie@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Christy Mearns",
		party: "Green",
		ward: "Anderston/City/Yorkhill",
		email: "christy.mearns@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Angus Millar",
		party: "SNP",
		ward: "Anderston/City/Yorkhill",
		email: "angus.millar@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Malcolm Mitchell",
		party: "SNP",
		ward: "Garscadden/Scotstounhill",
		email: "Malcolm.Mitchell@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Jon Molyneux",
		party: "Green",
		ward: "Pollokshields",
		email: "jon.molyneux@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Robert Mooney",
		party: "Labour",
		ward: "Canal",
		email: "robert.mooney@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Margaret Morgan",
		party: "SNP",
		ward: "Linn",
		email: "margaret.morgan@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Eva Murray",
		party: "Labour",
		ward: "Garscadden/Scotstounhill",
		email: "eva.murray@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Graeme Bruce",
		party: "Tory",
		ward: "Pentland Hills",
		email: "graeme.bruce@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Cecilia O'Lone",
		party: "Labour",
		ward: "Calton",
		email: "cecilia.o'lone@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Fiona Glasgow",
		party: "SNP",
		ward: "Pentland Hills",
		email: "Cllr.Fiona.Glasgow@edinburgh.gov.uk",
		twitter: "@FionaCllr",
	},
	{
		name: "Keiran O'Neill",
		party: "Labour",
		ward: "Maryhill",
		email: "Kieran.ONeill@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Jill Pidgeon",
		party: "Labour",
		ward: "Shettleston",
		email: "Jill.Pidgeon@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Linda Pike",
		party: "SNP",
		ward: "Calton",
		email: "Linda.Pike@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Hanif Raja",
		party: "Labour",
		ward: "Pollokshields",
		email: "hanif.raja@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Thomas Rannachan",
		party: "Labour",
		ward: "Springburn/Robroyston",
		email: "Thomas.Rannachan@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "George Redmond",
		party: "Labour",
		ward: "Calton",
		email: "George.Redmond@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Lana Reid-McConnell",
		party: "Green",
		ward: "Victoria Park",
		email: "Lana.ReidMcConnell@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie Roza Salih",
		party: "SNP",
		ward: "Greater Pollok",
		email: "Roza.Salih@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Franny Scally",
		party: "SNP",
		ward: "Maryhill",
		email: "franny.scally@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Bailie James Scanlon",
		party: "Labour",
		ward: "Southside Central",
		email: "james.scanlon@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Dr Soryia Siddique",
		party: "Labour",
		ward: "Southside Central",
		email: "soryia.siddique@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Kieran Turner",
		party: "Labour",
		ward: "East Centre",
		email: "Kieran.Turner@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Catherine Vallis",
		party: "Labour",
		ward: "Linn",
		email: "Catherine.Vallis@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Martha Wardrop",
		party: "Green",
		ward: "Hillhead",
		email: "martha.wardrop@glasgow.gov.uk",
		twitter: "none",
	},
	{
		name: "Alex Wilson",
		party: "SNP",
		ward: "Cardonald",
		email: "alex.wilson@glasgow.gov.uk",
		twitter: "none",
	},
];
  